import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { ArrowLeftBlack, ArrowRightBlack, CloseIcon } from 'assets/icons';
import { PointService } from 'services';

interface Props {
	onClose?: any;
	quantity_required?: number;
	prize_percent?: number;
}

class ModalChangePoints extends React.Component<Props> {

	state = {
		form: {
			quantity_required: this.props.quantity_required || '',
			prize_percent: this.props.prize_percent || '',
		}
	}

	submit = async () => {
		const res: any = await PointService.admin.save({
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha guardado la configuración correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="modal-change-price">
				<Input
					type="decimal"
					color="white"
					name="quantity_required"
					value={ this.state.form.quantity_required }
					label="Cantidad requerida para lograr descuento"
					onChange={ (e: any) => this.change(e) } />
				<Input
					type="percentage"
					color="white"
					name="prize_percent"
					value={ this.state.form.prize_percent }
					label="Porcentaje de descuento"
					onChange={ (e: any) => this.change(e) } />
				<div className="row row-buttons">
					<div className="col-md-6 text-center">
						<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
					<div className="col-md-6 text-center">
						<button className="btn btn-submit" onClick={ () => this.submit() }>
							Guardar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalChangePoints;